import WeatherLocations from 'owa-service/lib/contract/WeatherLocation';
import WeatherDailyConditions from 'owa-service/lib/contract/WeatherDailyConditions';

function renameProperty(o: Object, old_key: string, new_key: string) {
    Object.defineProperty(o, new_key, Object.getOwnPropertyDescriptor(o, old_key));
    delete o[old_key];
}

// We will be temporarily renaming the properties we get from the new weather service
// until we eventually get rid of our calls to the old service.
// VSO: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/112425/
export function convertToGetWeatherForecastResponse(weatherLocations: WeatherLocations) {
    renameProperty(weatherLocations.Conditions, 'temp', 'Temperature');
    renameProperty(weatherLocations.Conditions, 'cap', 'SkyText');
    renameProperty(weatherLocations.Conditions, 'pvdrIcon', 'SkyCode');
    renameProperty(weatherLocations.MultidayForecast, 'days', 'DailyForecasts');
    weatherLocations.MultidayForecast.DailyForecasts.map(value =>
        convertToWeatherDailyConditions(value)
    );
}

function convertToWeatherDailyConditions(dailyForecast: WeatherDailyConditions) {
    renameProperty(dailyForecast, 'precip', 'PrecipitationChance');
    renameProperty(dailyForecast, 'cap', 'SkyText');
    renameProperty(dailyForecast, 'pvdrIcon', 'SkyCode');
    renameProperty(dailyForecast, 'tempHi', 'High');
    renameProperty(dailyForecast, 'tempLo', 'Low');
}
